import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const revealFn = /* @__PURE__ */ createRecipe('reveal', {
  "variant": "rise",
  "delay": "0"
}, [])

const revealVariantMap = {
  "variant": [
    "rise",
    "scale"
  ],
  "delay": [
    "0",
    "1",
    "2",
    "3"
  ]
}

const revealVariantKeys = Object.keys(revealVariantMap)

export const reveal = /* @__PURE__ */ Object.assign(memo(revealFn.recipeFn), {
  __recipe__: true,
  __name__: 'reveal',
  __getCompoundVariantCss__: revealFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: revealVariantKeys,
  variantMap: revealVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, revealVariantKeys)
  },
  getVariantProps: revealFn.getVariantProps,
})